'use client';

import commonStyles from '@/styles/common.module.css';

import { Dialog, Button, Flex, Box } from '@radix-ui/themes';
import { Cross1Icon, LockClosedIcon } from '@radix-ui/react-icons';
import { isProduction } from '@/app/lib/utils/helpers';
import MockSignInDialogButtonContainer from '../mock-sign-in-dialog-button-container';
import SignInDialogButtonContainer from '../sign-in/sign-in-dialog-button-container';

interface Props {
  open: boolean;
  onClose: () => void;
  message: string;
}

export default function SessionExpiredDialog({
  open,
  onClose,
  message
}: Props) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={isOpen => !isOpen && onClose()}
    >
      <Dialog.Content
        aria-describedby={undefined}
        minWidth='450px'
        className={commonStyles.DialogContent}
      >
        <Box className={commonStyles.CloseDialogButton}>
          <Dialog.Close>
            <Button
              variant='ghost'
              color='gray'
              aria-label='Закрыть'
            >
              <Cross1Icon />
            </Button>
          </Dialog.Close>
        </Box>
        <Dialog.Title>
          <Flex gap='2'>
            <LockClosedIcon
              width='1.5rem'
              height='1.5rem'
            />
            Сессия истекла
          </Flex>
        </Dialog.Title>
        <Dialog.Description mb='6'>{message}</Dialog.Description>
        <Flex
          direction='column'
          justify='center'
          align='center'
          gap='2'
        >
          {isProduction() ? (
            <SignInDialogButtonContainer onClose={onClose} />
          ) : (
            <MockSignInDialogButtonContainer onClose={onClose} />
          )}

          <Dialog.Close>
            <Box width='360px'>
              <Button
                variant='outline'
                color='gray'
                style={{ width: '100%' }}
              >
                Отмена
              </Button>
            </Box>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
